//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '搜索资源',
    },
    value: {
      type: String,
      default: '',
    },
    showInput: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: '',
    },
    isSearch: {
      type: Boolean,
      default: true,
    },
    isClear: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      width: 0,
    };
  },
  computed: {
    autoWidth() {
      return this.type === 'auto_width'
    },
  },
  mounted() {
    if (this.autoWidth) {
      this.getSizeChange();
      window.addEventListener('resize', this.sizeChange);
    }
  },
  beforeDestroy() {
    if (this.autoWidth) {
      window.removeEventListener('resize', this.sizeChange);
    }
  },
  methods: {
    sizeChange() {
      window.requestAnimationFrame(this.getSizeChange);
    },
    getSizeChange() {
      const bigScreen = window.document.documentElement.offsetWidth >= 1440;
      this.width = bigScreen ? 360 : 240;
    },
    clearInput() {
      this.$emit('input', '');
    },
    search(e) {
      const keyDown = e.keyCode === 13;
      if (keyDown) {
        e.preventDefault();
        this.$emit('search');
      }
      this.setInputSensors()
    },
    updateSearchVal(e) {
      this.$emit('input', e.target.value);
    },
    isMobileSize() {
      const clientWidth = document.body.clientWidth;
      return clientWidth <= 640;
    },
    focus() {
      if (this.type === 'banner') {
        this.$emit('focus');
      }
      this.setInputSensors()
    },
    setInputSensors() {
      const type = this.type === 'banner' ? 'main' : 'navbar'
      this.$sensors.track('search_click', {
        action_position: 'community',
        action_parameter1: type,
      });
    },
    blur() {
      this.$emit('blur');
    }
  },
};
